import { render } from "./emergency.vue?vue&type=template&id=561a7321&scoped=true"
import script from "./emergency.vue?vue&type=script&lang=js"
export * from "./emergency.vue?vue&type=script&lang=js"

import "./emergency.vue?vue&type=style&index=0&id=561a7321&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561a7321"]])

export default __exports__